import React from 'react';

export default class SidebarBase extends React.Component {

  state = {
  }

  componentDidMount = async () => {
  }

}
